import React from 'react'

class NotFoundPage extends React.Component {
  render() {
    return <div>404: Not Found</div>
  }
}

export default NotFoundPage;